import React from 'react';
import ReactDOM from 'react-dom';
import TrainerRegistrationForm from '../components/trainer/TrainerRegistrationForm';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderTrainerRegistrationForm = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<TrainerRegistrationForm props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering TrainerRegistration:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};